import React from 'react';
import { useBreakpointHelpers } from '@sweetgreen/garnish';

import { LocationLayout as DesktopLocationLayout } from './LocationLayout.desktop';
import { LocationLayout as MobileLocationLayout } from './LocationLayout.mobile';
import type { LocationLayoutProps } from './LocationLayout.types';

export const LocationLayout = (props: LocationLayoutProps) => {
  const { currentBreakpoint } = useBreakpointHelpers();

  if (currentBreakpoint.isMobile) return <MobileLocationLayout {...props} />;

  return <DesktopLocationLayout {...props} />;
};
